<template>
    <div class="game-stats tmp-block-stats" :class="color">
        <h3>{{data.count.toLocaleString()}}</h3>
        <p class="text"><slot></slot></p>
        <tag :color="color">{{tag}}</tag>
    </div>
</template>

<script>
    import tag from './tag.vue'

    export default {
        name: "game_stats",
        components: {
            tag
        },
        props: {
            color: {
                type: String,
                default: "gray"
            },
            data: Object,
        },
        computed: {
            tag(){
                const d = this.data;
                if(d.position) return `${d.position.toLocaleString()} в топе`;
                else return 'еще не в топе';
            }
        }
    }
</script>

<style scoped lang="scss">
    .game-stats {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        h3{
            margin-bottom: 4px;
        }
        .text {
            font-weight: 600;
            font-size: 14px;
            line-height: 16px;
            margin-bottom: 12px;
        }

        background-color: $bg_light_plus;
        color: white;
        &.blue {
            background-color: rgba($blue, 0.12);
            box-shadow: 0 12px 24px rgba($blue, 0.08);

            .text {
                color: $blue;
            }
        }
        &.green {
            background-color: rgba($green, 0.12);
            box-shadow: 0 12px 24px rgba($green, 0.08);

            .text {
                color: $green;
            }
        }
        &.purple {
            background-color: rgba($purple, 0.12);
            box-shadow: 0 12px 24px rgba($purple, 0.08);

            .text {
                color: $purple;
            }
        }
        &.orange {
            background-color: rgba($orange, 0.12);
            box-shadow: 0 12px 24px rgba($orange, 0.08);

            .text {
                color: $orange;
            }
        }
        &.red {
            background-color: rgba($red, 0.12);
            box-shadow: 0 12px 24px rgba($red, 0.08);

            .text {
                color: $red;
            }
        }
    }
</style>